import { BaseBlok, BlokToComponentProps, blokToComponent, Link, RocheButton } from '@repo/roche-xx-shared';
import { RocheUIButtonAppearance, RocheUIButtonTarget, RocheUIHorizontalCenter } from '@rocheglobal/roche-ui';
import React, { FC, useRef } from 'react';

type RocheHorizontalCenterProps = BlokToComponentProps<{
  slotted: (BaseBlok & {
    right_icon?: string;
    left_icon?: string;
    href: Link;
    target: RocheUIButtonTarget;
    text: string;
    appearance: RocheUIButtonAppearance;
  })[];
  slot?: string;
}>;

export const RocheHorizontalCenter: FC<RocheHorizontalCenterProps> = ({ blok, slot, getComponent }) => {
  const elementRef = useRef<HTMLDivElement>(null);

  const children = blok?.slotted?.map((item, index) => {
    const component = blokToComponent({ blok: item, getComponent }, 'horizontal-center');
    if (item.component === 'roche-button') {
      // No matter what parents or other children, we hard-code the RocheButton without marginTop here.
      return (
        <RocheButton getComponent={getComponent} blok={item} hasMarginTop={false} key={`horizontal-center-${index}`} />
      );
    }
    return component;
  });

  return (
    <div ref={elementRef}>
      <RocheUIHorizontalCenter slot={slot}>{children}</RocheUIHorizontalCenter>
    </div>
  );
};
